import React from 'react';
import BaseIcon from './BaseIcon';

interface MinusIconProps {
  className?: string;
}

const MinusIcon: React.FC<MinusIconProps> = ({ className }) => (
  <BaseIcon className={className}>
    <path d="M5 12h14"></path>
  </BaseIcon>
);

export default MinusIcon;
